import React, { FC, useRef, useEffect, useState } from 'react';
import * as S from './styled';
import { useData } from './constants';
import { Slide } from './components/slide';
import { useT } from '@hooks';
import { Title } from '../title';

export const Reviews: FC = props => {
	const data = useData();
	const { T } = useT();

	return (
		<S.Container>
			<Title>Users love our plans</Title>
			<S.List>
				{data.map((item, index) => (
					<Slide key={item.name} {...item} />
				))}
			</S.List>
		</S.Container>
	);
};
